import { Clickable } from '@carvana/merch-components';
import { RecentSearch } from '~/contracts/home';
import useToggleSavedSearches, {
  ToggleSavedSearchSource
} from '~/hooks/home/useToggleSavedSearches';
import HeartWithBorder from '~/icons/HeartWithBorder';

type OwnProps = {
  search: RecentSearch;
};

export default function RecentSearchHeart({ search }: OwnProps) {
  const { savedSearch } = search;
  const toggleSavedSearch = useToggleSavedSearches({
    search,
    source: ToggleSavedSearchSource.HomeExp
  });

  return (
    <Clickable
      data-analytics-id={null} // event handled in the toggle hook
      data-qa="saved search"
      className="pointer-events-auto flex items-center"
      onClick={toggleSavedSearch}
    >
      <HeartWithBorder
        isFavorited={Boolean(savedSearch?.savedSearchId)}
        darkBlue
        className="h-20 w-20"
      />
    </Clickable>
  );
}
